"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Control = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = tslib_1.__importDefault(require("react"));

var react_select_1 = require("react-select");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var StyledControl = (0, styled_components_1.default)(react_select_1.components.Control)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), ui_blocks_1.FORM.field, function (_a) {
  var isFocused = _a.isFocused;
  return isFocused ? ui_blocks_1.INTERACTIVE.focus : '';
});

function Control(_a) {
  var children = _a.children,
      props = tslib_1.__rest(_a, ["children"]);

  var _b = props.selectProps.controlProps,
      controlProps = _b === void 0 ? {} : _b;
  var icon = controlProps.icon,
      iconColor = controlProps.iconColor,
      iconScale = controlProps.iconScale;
  return react_1.default.createElement(StyledControl, tslib_1.__assign({}, props), icon && react_1.default.createElement(ui_icon_1.Icon, {
    name: icon,
    color: iconColor,
    scale: iconScale
  }), children);
}

exports.Control = Control;
var templateObject_1;